
import * as actionTypes from './actionTypes';

export const resetSettingsState = () => {
  return {
    type: actionTypes.RESET_SETTINGS_STATE,

  };
}
export const initSettingsStart = () => {
  return {
    type: actionTypes.INIT_SETTINGS_START
  };
};

export const refreshSettings = () => {
  return window.location.reload();
};
export const setSettings = (fake, realSettings) => {
  return {
    type: actionTypes.SET_SETTINGS,
    fake: fake,
    realSettings:realSettings
  };
};
export const getAll = (mac) => {
  // sessionStorage.setItem("mac", mac);
  return {
    type: actionTypes.INIT_GET_ALL,
    rMac: mac
  };
};
export const checkFirmware = (rMac,token,sessionToken,wait, timerStart) => {

  return {
    type: actionTypes.CHECK_FIRMWARE,
    rMac:rMac,
    token:token,
    sessionToken:sessionToken,
    wait:wait,
    timerStart:timerStart
  }


}


export const fetchSettingsFailed = () => {
  return {
    type: actionTypes.FETCH_SETTINGS_FAILED
  };
};
export const changeSettingsFailed = (errorStatus) => {
  return {
    type: actionTypes.CHANGE_SETTINGS_FAILED,
    errorStatus: errorStatus
  }
}
export const changeSettingsSuccess = () => {
  return {
    type: actionTypes.CHANGE_SETTINGS_SUCCESS
  }
}
export const serviceRestoreSuccess = () => {
  return {
    type: actionTypes.SERVICE_RESTORE_SUCCESS,
  }
}
export const resetSettingsErrorSuccess = () => {
  return {
    type: actionTypes.RESET_SETTINGS_ERROR_SUCCESS
  }
}

export const initSettings = () => {
  return {
    type: actionTypes.INIT_SETTINGS,
  };
};

export const changeNamePass = (name, password, t) => {
  return {
    type: actionTypes.CHANGE_NAME_PASS,
    name: name,
    password: password,
    t: t
  };
}
export const rebootRouter = (all, restore) => {
  return {
    type: actionTypes.REBOOT_ROUTER,
    all:all,
    restore:restore
  };
}
export const resetRouter = () => {
  return {
    type: actionTypes.RESET_ROUTER
  };
}
export const optimizeRouter = () => {
  return {
    type: actionTypes.OPTIMIZE_ROUTER
  };
}
export const updateFirmware = () => {
  return {
    type: actionTypes.UPDATE_FIRMWARE
  };
}
export const runSpeedTest = () => {
  return {
    type: actionTypes.RUN_SPEED_TEST
  };
}
export const getSpeedTest = () => {
  return {
    type: actionTypes.GET_SPEED_TEST
  };
}
export const getFirmwareUpdate = (isInitial) => {
  return {
    isInitial:isInitial,
    type: actionTypes.GET_FIRMWARE_UPDATE
  };
}
export const getFirmwareUpdateStart = () => {
  return {
    type: actionTypes.GET_FIRMWARE_UPDATE_START
  };
}
export const getFirmwareUpdateFailed = () => {
  return {
    type: actionTypes.GET_FIRMWARE_UPDATE_FAILED
  };
}
export const setFirmwareUpdate = (firmwareUpdate) => {
  return {
    type: actionTypes.SET_FIRMWARE_UPDATE,
    firmwareUpdate: firmwareUpdate
  };
}
export const setWINVersion = (data) => {
  return {
    type: actionTypes.SET_WIN_VERSION,
    versions: data
  }
}
export const setFirmwareSpinnerUpdate = (SpinerUpdate) => {
  return {
    type: actionTypes.SET_FIRMWARE_SPINNER_UPDATE,
    firmwareDisplayUpdateSpinner: SpinerUpdate
  };
}

export const setOptimizeRouterSpinnerUpdate = (SpinerUpdate) => {
  return {
    type: actionTypes.SET_OPTIMIZE_ROUTER_SPINNER_UPDATE,
    optimizeRouterDisplayUpdateSpinner: SpinerUpdate
  };
}


